/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import Snackbar from 'components/Snackbar';

const Notification = (props) => {
  const { notification: { type, message } = {}, onClose, handleOnClose } = props;

  const getMessage = () => {
    let msg = message;

    // if message not defined
    if (!msg) {
      if (type === 'success') {
        msg = T.translate('notifications.updateSuccess');
      }
      if (type === 'error') {
        msg = T.translate('notifications.updateError');
      }
    }

    return msg;
  };

  return (
    <Snackbar
      open={type !== null}
      message={getMessage()}
      type={type}
      handleOnClose={handleOnClose}
      options={{
        onClose,
      }}
    />
  );
};

Notification.defaultProps = {};

Notification.propTypes = {
  notification: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Notification;
